<template>
  <ul class="list-unstyled flex gap-2 flex-wrap">
    <li v-for="(photo, index) in props.photos" class="snap-start" :key="index">
      <a :href="photo.src" target="_blank" rel="noopener" @click.prevent="onClick(index)">
        <img width="80" height="80" class="object-cover rounded-md" loading="lazy" :src="photo.src" :alt="photo.caption">
      </a>
    </li>
  </ul>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';

import initMosaicGallery, { addBackButton, addCaption } from '@/modules/misc/common/mosaic-gallery';

const emit = defineEmits(['track']);

const props = defineProps({
  photos: {
    type: Array,
    default: () => [],
    validator(value) {
      if (!Array.isArray(value)) {
        return false;
      }

      return value.every((photo) => {
        return (
          typeof photo.src === 'string' &&
          typeof photo.caption === 'string'
        );
      });
    },
  },
});

const onClick = (index) => {
  const galleryData = props.photos;

  emit('track', {
    section: 'reviews_modal',
    element: 'photos_in_reviews',
    element_value: index,
    interaction: 'click',
  });

  let lightbox = initMosaicGallery(galleryData, {
    escKey: true,
  });

  lightbox.on('close', () => {
    lightbox.destroy();
    lightbox = null;
  });

  lightbox.on('afterInit', () => {
    lightbox.on('change', () => {
      emit('track', {
        section: 'reviews_photo_gallery',
        element: 'photo',
        element_value: lightbox.pswp.currIndex,
        interaction: 'change',
      });
    });
  });

  addCaption(lightbox);
  addBackButton(lightbox);

  lightbox.init();
  lightbox.loadAndOpen(index);

  window.pswpLightboxReviews = lightbox; // store the lightbox instance globally for closing later
};
</script>
